import React, { Component } from 'react';

import { APIHandler, ExhibitionUsers } from 'C4';

import 'react-toastify/dist/ReactToastify.css';

export default class ExhibitionView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stands: [],
    };
  }

  componentWillMount() {
    this.getStandsAndFloor();
  }

  getStandsAndFloor() {
    APIHandler.getExhibitionStands(715).then((res) => {
      this.setState({ stands: res });
      const standIds = [];
      Object.values(res).map((item) => {
        Object.values(item.tiles).map((tile) => {
          if (tile.company_id) {
            standIds.push(tile.company_id);
          }
        });
      });
    });
  }

  render() {
    const { stands } = this.state;
    const params = new URLSearchParams(window.location.search);
    const categories = Object.values(stands).map((item) => {
      const icon = item.icon.replace('fa-', '');
      const title = `${item.title}`;
      const url = item.title.replace(/ /g, '-').toLowerCase();
      return (
        <ExhibitionUsers
          buttonIcon={icon}
          buttonPosition={url}
          buttonColor={item.color}
          title={title}
          url={url}
          stands={item.tiles}
          id={item.id}
          key={item.id}
        />
      );
    });
    return (
      <div className='exhibitionFloor'>
        <div className='gradient' />

        <div className='exhibition__container'>
          <img className='bgMap' src="https://front.travpromobile.com/697/world-map-2.png" />
          {categories}
        </div>
        {params.get("header") === 'false' && (
          <style>
            {
              "\
        .header { display: none; } .exhibitionFloor .exhibition__container { margin-top: 5rem !important; }"
            }
          </style>
        )}
      </div>
    );
  }
}
